<template>
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            <h4 class="modal-title">
                Responder Avaliação
            </h4>
        </div>

        <div class="modal-body">
            <!-- Info banner -->
            <div class="info-banner">
                <span>Sua resposta será exibida publicamente abaixo da avaliação enviada por {{ ratingUser.full_name }}.</span>
            </div>

            <!-- Original rating display -->
            <div class="original-rating-section">
                <h5 class="section-title">
                    Avaliação Original
                </h5>

                <div class="rating-card">
                    <div class="rating-header">
                        <div class="user-info">
                            <img :src="ratingUser.photo_url || '/images/default-avatar.png'" :alt="ratingUser.full_name" class="user-avatar">
                            <div class="user-details">
                                <h6 class="user-name">{{ ratingUser.full_name }}</h6>
                                <span class="rating-date">{{ rating.created_at }}</span>
                            </div>
                        </div>

                        <div class="rating-display">
                            <vue-star-rating
                                v-model="ratingScore"
                                name="rating"
                                :increment="0.5"
                                border-color="#ffc107"
                                :rounded-corners="true"
                                :star-size="20"
                                :read-only="true"
                                :show-rating="false">
                            </vue-star-rating>
                            <div class="rating-score">
                                <span class="score">{{ Number(rating.rating).toFixed(1) }}</span>
                                <span class="max-score">/5</span>
                            </div>
                        </div>
                    </div>

                    <div class="rating-comment" v-if="rating.comment_property_ad">
                        <p class="comment-text">
                            {{ rating.comment_property_ad }}
                        </p>
                    </div>
                    <hr/>
                    <div class="rating-comment" v-if="rating.comment_user">
                        <p class="comment-text">
                            {{ rating.comment_user }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- Reply form -->
            <div class="reply-form-section">
                <h5 class="section-title">
                    Sua Resposta
                </h5>

                <div class="form-group">
                    <textarea
                        v-model="reply.reply"
                        placeholder="Escreva sua resposta aqui... (mínimo 10 caracteres)"
                        rows="4"
                        class="form-control reply-textarea"
                        :class="{ 'is-invalid': replyError }">
                    </textarea>
                    <div class="invalid-feedback" v-if="replyError">
                        {{ replyError }}
                    </div>
                    <div class="char-counter">
                        <span :class="{ 'text-danger': reply.reply.length > 500 }">
                            {{ reply.reply.length }}/500 caracteres
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Action buttons -->
        <div class="modal-footer">
            <button type="button" class="btn btn-default btn-lg" data-dismiss="modal">
                Cancelar
            </button>
            <button
                type="button"
                class="btn btn-custom btn-lg reply-btn"
                @click="submitReply"
                :disabled="!isValidReply || submitting">
                <span v-if="!submitting">Enviar Resposta</span>
                <span v-else>Enviando...</span>
            </button>
        </div>
    </div>
</template>

<script>
import VueStarRating from "../../../../../../legacy/node_modules/vue-star-rating";
let ladda = require('../../../../../../legacy/node_modules/ladda');

export default {
    components: { VueStarRating },
    props: {
        rating: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            ratingScore: this.rating.rating,
            ratingUser: this.rating.rating_user,
            reply: {
                fk_rental_rating: this.rating.id,
                reply: '',
            },
            submitting: false,
            replyError: ''
        };
    },
    computed: {
        isValidReply() {
            return this.reply.reply.trim().length >= 10 && this.reply.reply.length <= 500;
        }
    },
    methods: {
        async submitReply() {
            if (!this.isValidReply) {
                this.replyError = 'A resposta deve ter entre 10 e 500 caracteres.';
                return;
            }

            this.submitting = true;
            this.replyError = '';

            try {
                const response = await axios.post('/rental/submit-rating-reply', this.reply);

                if (response.data.response) {
                    window.App.success('Resposta enviada com sucesso!');
                    this.$emit('close-modal');
                } else {
                    window.App.error('Erro ao enviar resposta!');
                }
            } catch (error) {
                window.App.error('Erro ao enviar resposta. Tente novamente.');
            } finally {
                this.submitting = false;
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.modal-content {
    border-radius: 12px;
    border: none;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.modal-header {
    border-bottom: 1px solid #e9ecef;
    padding: 20px 25px;

    .modal-title {
        font-weight: 600;
        color: #333;
        margin: 0;
    }
}

.modal-body {
    padding: 25px;
}

.info-banner {
    background: #e3f2fd;
    border: 1px solid #bbdefb;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 25px;
    color: #333;
    font-size: 14px;
    display: flex;
    align-items: center;
}

.section-title {
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
}

.original-rating-section {
    margin-bottom: 30px;
}

.rating-card {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 20px;
    border-left: 4px solid #ffc107;
}

.rating-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.user-info {
    display: flex;
    align-items: center;

    .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 12px;
        border: 2px solid #e9ecef;
    }

    .user-details {
        .user-name {
            margin: 0 0 3px 0;
            font-weight: 600;
            color: #333;
            font-size: 14px;
        }

        .rating-date {
            color: #6c757d;
            font-size: 12px;
        }
    }
}

.rating-display {
    text-align: center;

    .rating-score {
        margin-top: 5px;

        .score {
            font-size: 16px;
            font-weight: 700;
            color: #333;
        }

        .max-score {
            font-size: 16px;
            font-weight: 400;
            color: #6c757d;
        }
    }
}

.rating-comment {
    .comment-text {
        margin: 0;
        line-height: 1.6;
        color: #495057;
        font-style: italic;
        font-size: 14px;
    }
}

.reply-form-section {
    .form-group {
        margin-bottom: 0;
    }
}

.reply-textarea {
    border-radius: 8px;
    border: 1px solid #ced4da;
    padding: 15px;
    font-size: 14px;
    line-height: 1.5;
    resize: vertical;
    min-height: 120px;

    &:focus {
        border-color: #007bff;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }

    &.is-invalid {
        border-color: #dc3545;
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
    }
}

.char-counter {
    text-align: right;
    margin-top: 8px;
    font-size: 12px;
    color: #6c757d;
}

.modal-footer {
    border-top: 1px solid #e9ecef;
    padding: 20px 25px;
    text-align: right;

    .btn {
        margin-left: 10px;
        border-radius: 6px;
        font-weight: 500;
    }

    .reply-btn {
        min-width: 140px;
    }
}

// Responsive design
@media (max-width: 768px) {
    .rating-header {
        flex-direction: column;
        text-align: center;
        gap: 15px;
    }

    .user-info {
        justify-content: center;
    }

    .modal-footer {
        text-align: center;

        .btn {
            margin: 5px;
            width: 100%;
        }
    }
}

// Close button
.close {
    opacity: 0.7;
    transition: opacity 0.2s;

    &:hover {
        opacity: 1;
    }
}
</style>